@if(request) {
  @if(request.rejectReason) {
    <div>
      <span class="text-danger"><fa-icon icon="times"></fa-icon> Raison du refus @if(request.partial) { partiel } :</span>
      <p>
        {{ request.rejectReason }}
      </p>
    </div>
  }
  <div>
    <h2>Demandeur</h2>
    <ul>
      <li>
        Structure :
        <a
          [href]="crmUrl + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DAccounts%26action%3DDetailView%26record%3D' + request.contact.account.crmId"
        >{{ request.contact.account.name }}</a>
      </li>
      <li>
        Prénom et nom :
        <a
          [href]="crmUrl + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DContacts%26action%3DDetailView%26record%3D' + request.contact.crmId"
        >{{ request.contact.firstname }} {{ request.contact.lastname }}</a>
      </li>
    </ul>
  </div>

  <div>
    <h2>À ajouter</h2>
    <h3>Informations générales</h3>
    <ul>
      <li>Nom : <span class="text-primary cursor-pointer icon-hover" ngbTooltip="Copier" appCopy="Nom">{{ request.coords.lastname }}
        <fa-icon icon="copy"></fa-icon></span></li>
      <li>Prénom : <span class="text-primary cursor-pointer icon-hover" ngbTooltip="Copier" appCopy="Prénom">{{ request.coords.firstname }}
        <fa-icon icon="copy"></fa-icon></span></li>
      <li>Mail : <span class="text-primary cursor-pointer icon-hover" ngbTooltip="Copier" appCopy="Mail">{{ request.coords.email }}
        <fa-icon icon="copy"></fa-icon></span></li>
      <li>Téléphone : <span class="text-primary cursor-pointer icon-hover" ngbTooltip="Copier" appCopy="Téléphone">{{ request.coords.phone }}
        <fa-icon icon="copy"></fa-icon></span></li>
    </ul>

    <h3>Type de profil</h3>
    <ul>
      <li>Fonction :
        <span class="text-primary cursor-pointer icon-hover" ngbTooltip="Copier" appCopy="Fonction">{{ request.profile.function }}
          <fa-icon icon="copy"></fa-icon></span>
      </li>
      <li>Profil demandé : {{ request.profile.profile }}</li>
    </ul>

    <h3>Produits demandés</h3>
    @for(p of request.products | keyvalue; track p) {
      <div>
        @if(getCategoryFromSlug(p.key); as cat) {
          <app-badge [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"></app-badge>
        }
        <ul id="produit">
          <li>Transfert de compétence : {{ p.value.transfert }}</li>

          @if(p.value.transfert === 'interne') {
            <li>Nom et prénom du formateur :  {{ p.value.formateur }}</li>
          } @else {
            <li>Nom et prénom du consultant : {{ p.value.consultant }}</li>
          }
          @if(p.value.replace === 'yes') {
            <li>Remplace un utilisateur existant : {{ p.value.oldreferentname }}
              &lt;{{ p.value.oldreferentmail }}&gt;
            </li>
          } @else {
            <li>Ne remplace pas d'utilisateur existant</li>
          }
        </ul>
      </div>
    }


    <h3>Informations complémentaires</h3>
    <p style="white-space: pre-wrap; word-break: break-word;">{{ request.infos.infos }}</p>
    @if(request.infos.rgpd) {
      <ul>
        <li>RGPD accepté</li>
      </ul>
    }
  </div>
}
